import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

export const tableTextStyle = css`
    padding-right: 8px;
    font-size: 12px;
    line-height: 18px;
    color: ${Colors.Black.V100};
`;
